import * as React from "react";
import { cn } from "@/lib/cn";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ className, type = "text", ...rest }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          "h-9 w-full rounded-md border border-border bg-bg-elevated px-3 text-sm",
          "text-fg placeholder:text-fg-faint",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus",
          "disabled:opacity-50",
          className,
        )}
        {...rest}
      />
    );
  },
);
